var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.containerClass,
      style: { display: _vm.fullWidth ? "flex" : "unset" },
    },
    [
      _c(
        "div",
        {
          class: `wrapper-controller${_vm.fullWidth ? " full" : ""}`,
          style: { marginTop: `${_vm.dense === true ? "0" : "8px"}` },
        },
        [
          _c("div", { staticClass: "input-header" }, [
            _c("div", {
              staticClass: "input-header__left",
              style: {
                borderTopLeftRadius: `${_vm.borderRadius}px`,
                width: `${_vm.borderRadius * 2}px`,
                height: `${_vm.borderRadius * 2}px`,
                padding: `${_vm.borderRadius}px`,
                flexGrow: `${_vm.centerLabel ? "1" : "unset"}`,
              },
            }),
            _c(
              "div",
              {
                staticClass: "input-header__center",
                style: { alignItems: "end" },
              },
              [
                _c("span", { staticClass: "input-header__center--label" }, [
                  _vm._v(_vm._s(_vm.label)),
                ]),
                _vm.info.length > 0
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-icon",
                                    _vm._g(
                                      {
                                        staticClass: "input-info",
                                        attrs: { size: "1em", color: "blue" },
                                      },
                                      on
                                    ),
                                    [_vm._v(" fas fa-info-circle ")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3112566139
                        ),
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.info))])]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("div", {
              staticClass: "input-header__right",
              style: {
                borderTopRightRadius: `${_vm.borderRadius}px`,
                width: `${_vm.borderRadius * 2}px`,
                height: `${_vm.borderRadius * 2}px`,
                padding: `${_vm.borderRadius * 2}px`,
              },
            }),
          ]),
          _c("div", { staticClass: "input-body" }, [
            _c(
              "div",
              {
                class: _vm.fullWidth
                  ? "input-body__slot--full"
                  : "input-body__slot",
                style: { flexWrap: _vm.flex ? "wrap" : "nowrap" },
              },
              [_vm._t("default")],
              2
            ),
          ]),
          _c("div", {
            staticClass: "input-footer",
            style: {
              borderBottomLeftRadius: `${_vm.borderRadius}px`,
              borderBottomRightRadius: `${_vm.borderRadius}px`,
              height: `${_vm.borderRadius}px`,
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }